import { css, DefaultTheme, SimpleInterpolation, ThemedCssFunction } from 'styled-components';
import BREAKPOINTS from '../../../constants/BREAKPOINTS';
import BREAKPOINT_LIST from '../../../constants/BREAKPOINT_LIST';

export interface MediaType {
  xs: ThemedCssFunction<DefaultTheme>;
  sm: ThemedCssFunction<DefaultTheme>;
  md: ThemedCssFunction<DefaultTheme>;
  lg: ThemedCssFunction<DefaultTheme>;
  ll: ThemedCssFunction<DefaultTheme>;
  xl: ThemedCssFunction<DefaultTheme>;
  xxl: ThemedCssFunction<DefaultTheme>;
}

/**
 * @since 0.14.0
 */
const media: MediaType = (() => BREAKPOINT_LIST.reduce((result: MediaType, breakpoint) => {
  const size = breakpoint.toUpperCase() as Uppercase<typeof breakpoint>;

  result[breakpoint] = (
    <P extends {}>(props: P, ...args: SimpleInterpolation[]) => css`
      @media (min-width: ${({ theme }) => (theme.breakpoints || BREAKPOINTS)[size][0]}px) {
        ${css<P>(props, ...args)}
      }
    `
  ) as ThemedCssFunction<DefaultTheme>;

  return result;
}, {} as MediaType))();

/**
 * @component
 * @visibleName media
 */
export default media;
